var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgExplode(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_11113_58793)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.4184 12.3652C23.4184 9.82552 21.3601 7.76709 18.8204 7.76709C18.165 7.76709 16.9781 8.15401 16.9781 8.15401L8.19152 9.08047C8.19152 9.08047 6.37275 8.02215 5.25752 8.02215C2.71712 8.02215 0.658691 10.0806 0.658691 12.6203C0.658691 12.7789 0.666724 12.9356 0.68212 13.0902C0.930471 19.1558 5.91287 24.0002 12.0386 24.0002C18.3237 24.0002 23.4184 18.9053 23.4184 12.6203C23.4184 12.5855 23.4124 12.5527 23.4106 12.5179C23.4124 12.467 23.4184 12.4168 23.4184 12.3652Z",
    fill: "url(#paint0_radial_11113_58793)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.1568 9.10636C19.5268 8.94303 19.4813 9.36476 18.6827 9.27103C17.9008 9.17932 18.9699 8.77634 18.5522 8.54004C18.4116 8.46039 18.2101 8.44364 17.9618 8.47443C17.2575 8.56079 6.61264 8.83859 6.21569 9.03005C5.86291 9.20008 5.65405 9.39688 5.33341 9.09766C4.92976 8.72144 4.35207 8.93835 4.18471 9.06352C3.96916 9.22552 3.92431 9.54684 4.34134 9.91835C4.75705 10.1995 5.46126 10.4934 6.66085 10.6942C6.79272 10.7163 6.90518 10.725 7.01027 10.729C7.83164 10.7564 7.94543 9.6111 9.10551 9.58031C9.86596 9.56023 16.5714 10.2966 17.1237 10.2216C17.1913 10.2122 17.2622 10.2055 17.3439 10.2055C18.3902 10.2055 18.6332 11.1762 19.7464 10.4171C20.2183 10.0335 20.9588 9.31387 20.1568 9.10636Z",
    fill: "#F19020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.0542 6.375C5.93194 7.25438 6.55493 8.18614 6.99179 8.97969C7.31798 9.57229 7.54274 10.0906 7.67586 10.4413C8.383 10.4649 8.48099 10.0554 9.47974 10.029C10.1344 10.0117 10.5073 10.4718 10.9914 10.7367C11.857 11.2101 12.472 10.3163 13.1347 10.3163C13.6246 10.3163 14.4136 11.0114 14.9651 10.7563C15.7645 10.386 16.0162 10.2838 16.4917 10.2188C16.6773 9.76324 16.8099 9.02865 17.1044 8.50288C17.5309 7.74041 18.4464 6.40451 19.1167 5.8125L5.0542 6.37614V6.375Z",
    fill: "#F36C24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.5258 6.50297C19.4917 4.78101 5.22203 6.51244 5.62508 6.96994C6.19561 7.61824 6.89547 8.83844 6.89547 8.83844C6.89547 8.83844 9.64238 10.2636 11.7177 8.46745C13.1614 9.35637 15.1824 9.04169 16.0844 7.51395C16.0844 7.51395 16.7871 7.7824 17.4997 7.82862C17.4997 7.82862 18.05 6.98415 18.5258 6.50297Z",
    fill: "#CE5C1F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.36074 13.6952C9.36074 14.6812 8.76094 15.4805 8.02193 15.4805C7.28222 15.4805 6.68311 14.6812 6.68311 13.6952C6.68311 12.7091 7.28222 11.9099 8.02193 11.9099C8.76094 11.9099 9.36074 12.7091 9.36074 13.6952ZM17.3936 13.6945C17.3936 14.6805 16.7945 15.4798 16.0548 15.4798C15.3151 15.4798 14.716 14.6805 14.716 13.6945C14.716 12.7091 15.3158 11.9092 16.0548 11.9092C16.7945 11.9099 17.3936 12.7091 17.3936 13.6945Z",
    fill: "#65471B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.8237 2.39514C20.663 2.39514 20.5111 2.42526 20.3645 2.4681C19.9038 1.90245 19.211 1.53361 18.4245 1.53361C18.3663 1.53361 18.3114 1.547 18.2538 1.55102C17.7625 0.997416 17.0529 0.641291 16.2543 0.641291C15.2468 0.641291 14.38 1.20292 13.9207 2.02429C13.6891 1.4901 13.1583 1.1159 12.5391 1.1159C12.0585 1.1159 11.6361 1.34484 11.3603 1.69494C11.0202 0.71091 10.0964 0 8.99726 0C8.11164 0 7.33714 0.461222 6.88997 1.15339C6.7668 1.13397 6.64363 1.11456 6.5151 1.11456C5.55651 1.11456 4.73381 1.65812 4.31074 2.44802C4.17486 2.42257 4.03629 2.40585 3.89304 2.40585C2.64527 2.40585 1.63379 3.41732 1.63379 4.66509C1.63379 5.91287 2.64527 6.92434 3.89304 6.92434C4.28664 6.92434 4.65281 6.81791 4.97346 6.63984C5.22516 6.82862 5.53442 6.94509 5.87381 6.94509C5.97088 6.94509 6.06459 6.93439 6.1563 6.91631C6.72864 7.83941 7.74079 8.45796 8.90689 8.45796C10.0509 8.45796 11.053 7.86553 11.6334 6.97388C12.1153 7.56429 12.8396 7.94919 13.661 7.94919C14.876 7.94919 15.8881 7.12048 16.1887 6.00056C16.2115 6.00122 16.2322 6.00726 16.255 6.00726C16.4444 6.00726 16.6292 5.9865 16.8079 5.94902C17.2457 6.32121 17.806 6.55416 18.4258 6.55416C19.2118 6.55416 19.9053 6.18531 20.3651 5.61967C20.5117 5.6625 20.6638 5.69263 20.8243 5.69263C21.7348 5.69263 22.4731 4.95428 22.4731 4.04389C22.4731 3.1335 21.734 2.39514 20.8237 2.39514Z",
    fill: "url(#paint1_radial_11113_58793)"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_df_11113_58793)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.5961 5.1819C19.3802 5.1819 20.0159 4.54624 20.0159 3.76209C20.0159 2.97795 19.3802 2.34229 18.5961 2.34229C17.8119 2.34229 17.1763 2.97795 17.1763 3.76209C17.1763 4.54624 17.8119 5.1819 18.5961 5.1819Z",
    fill: "#F7ECC9"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_df_11113_58793)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.5938 4.125C17.1633 4.125 17.625 3.6633 17.625 3.09375C17.625 2.5242 17.1633 2.0625 16.5938 2.0625C16.0242 2.0625 15.5625 2.5242 15.5625 3.09375C15.5625 3.6633 16.0242 4.125 16.5938 4.125Z",
    fill: "#F7ECC9"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_df_11113_58793)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.1903 5.24554C15.7146 5.19688 16.125 4.75575 16.125 4.21875C16.125 3.6492 15.6633 3.1875 15.0938 3.1875C14.7409 3.1875 14.4295 3.36467 14.2436 3.63489C14.1025 3.58793 13.9517 3.5625 13.7948 3.5625C13.0107 3.5625 12.375 4.19816 12.375 4.98231C12.375 5.76645 13.0107 6.40211 13.7948 6.40211C14.489 6.40211 15.0668 5.90391 15.1903 5.24554Z",
    fill: "#F2E5B6"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_df_11113_58793)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.375 4.01083C12.375 3.35784 11.8435 2.82801 11.1878 2.82801C10.9855 2.82801 10.7975 2.88328 10.631 2.97195C10.493 2.643 10.1671 2.41148 9.78619 2.41148C9.47453 2.41148 9.19971 2.56746 9.03428 2.80446C8.66601 2.46347 8.17628 2.25 7.63378 2.25C6.66915 2.25 5.86612 2.91229 5.64133 3.80338C5.44071 3.60249 5.16313 3.47771 4.85588 3.47771C4.24523 3.47771 3.75 3.97087 3.75 4.57897C3.75 5.18707 4.24523 5.68024 4.85588 5.68024C5.24228 5.68024 5.58086 5.48265 5.77873 5.18379C6.06291 5.77547 6.61914 6.20897 7.2897 6.32173C7.50407 6.68846 7.89816 6.9375 8.35491 6.9375C8.94523 6.9375 9.43716 6.52479 9.56027 5.97416C9.73836 6.07269 9.94009 6.13399 10.1577 6.13399C10.7458 6.13399 11.2361 5.72402 11.3614 5.17613C11.9342 5.09128 12.375 4.6047 12.375 4.01083Z",
    fill: "#F7ECC9"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M14.7946 19.7994C14.7946 20.8537 13.6292 21.4732 12.1927 21.4732C10.7562 21.4732 9.59082 20.8537 9.59082 19.7994C9.59082 18.7452 10.7562 17.5986 12.1927 17.5986C13.6292 17.5986 14.7946 18.7452 14.7946 19.7994Z",
    fill: "#65471B"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_df_11113_58793)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.34375 4.125C8.9133 4.125 9.375 3.6633 9.375 3.09375C9.375 2.5242 8.9133 2.0625 8.34375 2.0625C7.7742 2.0625 7.3125 2.5242 7.3125 3.09375C7.3125 3.6633 7.7742 4.125 8.34375 4.125Z",
    fill: "#F7ECC9"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_df_11113_58793",
    x: 13.1763,
    y: -1.65771,
    width: 10.8394,
    height: 12.8398,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.807843 0 0 0 0 0.360784 0 0 0 0 0.121569 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_11113_58793"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_11113_58793",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    result: "effect2_foregroundBlur_11113_58793"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_df_11113_58793",
    x: 11.5625,
    y: -1.9375,
    width: 10.0625,
    height: 12.0625,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.807843 0 0 0 0 0.360784 0 0 0 0 0.121569 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_11113_58793"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_11113_58793",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    result: "effect2_foregroundBlur_11113_58793"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_df_11113_58793",
    x: 8.375,
    y: -0.8125,
    width: 11.75,
    height: 13.2148,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.807843 0 0 0 0 0.360784 0 0 0 0 0.121569 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_11113_58793"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_11113_58793",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    result: "effect2_foregroundBlur_11113_58793"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_df_11113_58793",
    x: -0.25,
    y: -1.75,
    width: 16.625,
    height: 14.6875,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.807843 0 0 0 0 0.360784 0 0 0 0 0.121569 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_11113_58793"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_11113_58793",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    result: "effect2_foregroundBlur_11113_58793"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_df_11113_58793",
    x: 3.3125,
    y: -1.9375,
    width: 10.0625,
    height: 12.0625,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.807843 0 0 0 0 0.360784 0 0 0 0 0.121569 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_11113_58793"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_11113_58793",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    result: "effect2_foregroundBlur_11113_58793"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_11113_58793",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(11.7617 15.6203) rotate(-35.4831) scale(9.74488 9.21208)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#FDE030"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#F7C02B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F4A223"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_11113_58793",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(11.3435 4.96875) rotate(169.611) scale(11.4375 4.29306)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E29541"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F8EFCF"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_11113_58793"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExplode);
export default __webpack_public_path__ + "static/media/EXPLODE.0d2f2e7131f0902499d80da8c1888c02.svg";
export { ForwardRef as ReactComponent };